var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vehicle-insert-data"}},[_c('basic-insert-data',{ref:"basicInsertData",attrs:{"masterName":"車両","inputTypes":_vm.inputTypes,"backTo":"addon-port-master-vehicle-master"},on:{"insertData":_vm.insertData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }